module.exports = __webpack_public_path__ + "static/media/at.d0c2483d.svg";